import { Application, ApplicationStatus } from '../../services/apply';
import { ActionInterface } from '../../utils/redux';
import { ApplyActions } from './actions';
import ApplyState, { ApplyStateInterface } from './state';

const INITIAL_STATE = new ApplyState();

export default function applyReducer(
  state = INITIAL_STATE,
  action: ActionInterface<ApplyActions>
): ApplyStateInterface {
  switch (action.type) {
    case ApplyActions.createLeaseApplicationStart:
      return createLeaseApplicationStart(state);
    case ApplyActions.createLeaseApplicationSuccess:
      return createLeaseApplicationSuccess(state, action);
    case ApplyActions.createLeaseApplicationError:
      return createLeaseApplicationError(state, action);
    case ApplyActions.getLeaseApplicationsStart:
      return getLeaseApplicationsStart(state);
    case ApplyActions.getLeaseApplicationsSuccess:
      return getLeaseApplicationsSuccess(state, action);
    case ApplyActions.getLeaseApplicationsError:
      return getLeaseApplicationsError(state, action);
    case ApplyActions.updateLeaseApplicationStart:
      return updateLeaseApplicationStart(state);
    case ApplyActions.updateLeaseApplicationSuccess:
      return updateLeaseApplicationSuccess(state, action);
    case ApplyActions.updateLeaseApplicationError:
      return updateLeaseApplicationError(state, action);
    case ApplyActions.payApplicationFeeStart:
      return payApplicationFeeStart(state);
    case ApplyActions.payApplicationFeeSuccess:
      return payApplicationFeeSuccess(state, action);
    case ApplyActions.payApplicationFeeError:
      return payApplicationFeeError(state, action);
    default:
      return state;
  }
}

// reducers
function createLeaseApplicationStart(
  state: ApplyStateInterface
): ApplyStateInterface {
  return { ...state, error: undefined };
}
function createLeaseApplicationSuccess(
  state: ApplyStateInterface,
  action: ActionInterface<ApplyActions, Application>
): ApplyStateInterface {
  return { ...state, application: action.payload || null, error: null };
}
function createLeaseApplicationError(
  state: ApplyStateInterface,
  action: ActionInterface<ApplyActions>
): ApplyStateInterface {
  return { ...state, application: null, error: action.payload };
}

function getLeaseApplicationsStart(
  state: ApplyStateInterface
): ApplyStateInterface {
  return { ...state, error: undefined };
}
function getLeaseApplicationsSuccess(
  state: ApplyStateInterface,
  action: ActionInterface<ApplyActions, Application[]>
): ApplyStateInterface {
  const application = action.payload
    ? action.payload.find(a => a.status === ApplicationStatus.pending)
    : null;
  return { ...state, application: application || null, error: null };
}
function getLeaseApplicationsError(
  state: ApplyStateInterface,
  action: ActionInterface<ApplyActions>
): ApplyStateInterface {
  return { ...state, application: null, error: action.payload };
}

function updateLeaseApplicationStart(
  state: ApplyStateInterface
): ApplyStateInterface {
  return { ...state, error: undefined };
}
function updateLeaseApplicationSuccess(
  state: ApplyStateInterface,
  action: ActionInterface<ApplyActions, Application>
): ApplyStateInterface {
  return { ...state, application: action.payload || null, error: null };
}
function updateLeaseApplicationError(
  state: ApplyStateInterface,
  action: ActionInterface<ApplyActions>
): ApplyStateInterface {
  return { ...state, application: null, error: action.payload };
}

function payApplicationFeeStart(
  state: ApplyStateInterface
): ApplyStateInterface {
  return { ...state, error: undefined };
}
function payApplicationFeeSuccess(
  state: ApplyStateInterface,
  action: ActionInterface<ApplyActions, Application>
): ApplyStateInterface {
  return { ...state, application: action.payload || null, error: null };
}
function payApplicationFeeError(
  state: ApplyStateInterface,
  action: ActionInterface<ApplyActions>
): ApplyStateInterface {
  return { ...state, application: null, error: action.payload };
}
